import { useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../home/components/Footer";
import { contactInfo } from "../../mocks/homeData";
import { usePageMeta } from "../../hooks/usePageMeta";


export default function ContactPage() {
  usePageMeta({
    title: "Iletisim | Hangar Muhendislik",
    description:
      "Ucretsiz kesif ve teklif sureci icin Hangar Muhendislik ile iletisime gecin. Ankara merkezli, Turkiye geneli hizmet.",
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const whatsappText = [
      "Merhaba Hangar Muhendislik,",
      `Ad Soyad: ${formData.name}`,
      `Telefon: ${formData.phone}`,
      `E-posta: ${formData.email}`,
      `Konu: ${formData.subject || "Genel talep"}`,
      `Mesaj: ${formData.message}`,
    ].join("\n");

    const whatsappUrl = `https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent(whatsappText)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");

    await new Promise((resolve) => setTimeout(resolve, 500));
    setIsSubmitting(false);
    setIsSubmitted(true);
    setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    setTimeout(() => setIsSubmitted(false), 4000);
  };

  return (
    <div className="font-body antialiased">
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="relative h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden bg-navy">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/4cd7994c-3362-45fb-b59a-e59524ed7708_img-3.jpeg?v=d9acff705403eef0f989036c6c21b62c"
              alt="İletişim Arkaplan"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/50 to-navy/70" />
          <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 text-center">
            <div className="inline-block w-12 h-1 rounded-full bg-copper mb-6" />
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4">
              İletişim
            </h1>
            <p className="font-body text-base md:text-lg text-white/70 max-w-2xl mx-auto">
              Projeniz için ücretsiz keşif ve fiyat teklifi almak için bize ulaşın. 24 saat içinde dönüş yapıyoruz.
            </p>
          </div>
        </section>

        {/* Contact Content */}
        <section className="bg-white py-16 md:py-24 lg:py-32">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 md:gap-16 items-start">
              {/* Contact Info */}
              <div>
                <div className="inline-block w-12 h-1 rounded-full bg-copper mb-6" />
                <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4">
                  Bize Ulaşın
                </h2>
                <p className="font-body text-base md:text-lg text-gray-600 leading-relaxed mb-8">
                  Hangar Mühendislik San.Tic.A.Ş. olarak Ankara merkezli olmak üzere Türkiye'nin dört bir yanına hizmet sunuyoruz.
                </p>
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-copper/10 flex items-center justify-center flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center text-copper">
                        <i className="ri-phone-line text-xl" />
                      </div>
                    </div>
                    <div>
                      <p className="font-body text-xs text-gray-500 mb-0.5">Telefon</p>
                      <a href={`tel:${contactInfo.phone.replace(/\s/g, "")}`} className="font-body text-base text-navy font-medium hover:text-copper transition-colors">
                        {contactInfo.phone}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-copper/10 flex items-center justify-center flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center text-copper">
                        <i className="ri-phone-line text-xl" />
                      </div>
                    </div>
                    <div>
                      <p className="font-body text-xs text-gray-500 mb-0.5">Telefon</p>
                      <a href={`tel:${contactInfo.phoneSecondary.replace(/\s/g, "")}`} className="font-body text-base text-navy font-medium hover:text-copper transition-colors">
                        {contactInfo.phoneSecondary}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-copper/10 flex items-center justify-center flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center text-copper">
                        <i className="ri-mail-line text-xl" />
                      </div>
                    </div>
                    <div>
                      <p className="font-body text-xs text-gray-500 mb-0.5">E-posta</p>
                      <a href={`mailto:${contactInfo.email}`} className="font-body text-base text-navy font-medium hover:text-copper transition-colors">
                        {contactInfo.email}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-copper/10 flex items-center justify-center flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center text-copper">
                        <i className="ri-map-pin-line text-xl" />
                      </div>
                    </div>
                    <div>
                      <p className="font-body text-xs text-gray-500 mb-0.5">Adres</p>
                      <p className="font-body text-base text-navy font-medium">{contactInfo.address}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-full bg-copper/10 flex items-center justify-center flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center text-copper">
                        <i className="ri-time-line text-xl" />
                      </div>
                    </div>
                    <div>
                      <p className="font-body text-xs text-gray-500 mb-0.5">Çalışma Saatleri</p>
                      <p className="font-body text-base text-navy font-medium">{contactInfo.workingHours}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Form */}
              <div className="bg-white rounded-xl p-6 md:p-8 shadow-xl border border-gray-100">
                {isSubmitted ? (
                  <div className="text-center py-8">
                    <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                      <div className="w-8 h-8 flex items-center justify-center text-green-600">
                        <i className="ri-check-line text-3xl" />
                      </div>
                    </div>
                    <h3 className="font-heading font-bold text-xl text-navy mb-2">Teşekkürler!</h3>
                    <p className="font-body text-sm text-gray-600">
                      Mesajınız alındı. En kısa sürede size dönüş yapacağız.
                    </p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <h3 className="font-heading font-bold text-xl text-navy mb-4">Teklif Alın</h3>
                    <div>
                      <input
                        type="text"
                        placeholder="Adınız Soyadınız"
                        required
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        className="w-full font-body text-sm px-4 py-3 rounded-md border border-gray-200 focus:border-copper focus:ring-1 focus:ring-copper/20 outline-none transition-all placeholder:text-gray-400"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="E-posta Adresiniz"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        className="w-full font-body text-sm px-4 py-3 rounded-md border border-gray-200 focus:border-copper focus:ring-1 focus:ring-copper/20 outline-none transition-all placeholder:text-gray-400"
                      />
                    </div>
                    <div>
                      <input
                        type="tel"
                        placeholder="Telefon Numaranız"
                        required
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        className="w-full font-body text-sm px-4 py-3 rounded-md border border-gray-200 focus:border-copper focus:ring-1 focus:ring-copper/20 outline-none transition-all placeholder:text-gray-400"
                      />
                    </div>
                    <div>
                      <select
                        value={formData.subject}
                        onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                        className="w-full font-body text-sm px-4 py-3 rounded-md border border-gray-200 focus:border-copper focus:ring-1 focus:ring-copper/20 outline-none transition-all text-gray-400"
                      >
                        <option value="">Konu Seçin</option>
                        <option value="hangar">Hangar Yapıları</option>
                        <option value="fabrika">Fabrika Yapıları</option>
                        <option value="depo">Depo & Antrepo</option>
                        <option value="celik">Çelik Konstrüksiyon</option>
                        <option value="diger">Diğer</option>
                      </select>
                    </div>
                    <div>
                      <textarea
                        placeholder="Projeniz hakkında kısa bilgi..."
                        rows={4}
                        required
                        maxLength={500}
                        value={formData.message}
                        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                        className="w-full font-body text-sm px-4 py-3 rounded-md border border-gray-200 focus:border-copper focus:ring-1 focus:ring-copper/20 outline-none transition-all resize-none placeholder:text-gray-400"
                      />
                      <p className="font-body text-xs text-gray-400 mt-1 text-right">{formData.message.length}/500</p>
                    </div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-copper hover:bg-copper-dark text-white font-heading font-semibold text-base py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                    >
                      {isSubmitting ? (
                        <span className="flex items-center justify-center gap-2">
                          <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                          Gönderiliyor...
                        </span>
                      ) : (
                        "Teklif Al"
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Map */}
        <section className="bg-gray-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-navy mb-2">
                Bizi Ziyaret Edin
              </h2>
              <p className="font-body text-base text-gray-600">
                {contactInfo.address}
              </p>
            </div>
            <div className="rounded-xl overflow-hidden border border-gray-200 shadow-lg h-[400px] md:h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.0!2d32.6333!3d40.0833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDA1JzAwLjAiTiAzMsKwMzgnMDAuMCJF!5e0!3m2!1str!2str!4v1"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Hangar Mühendislik Konum"
                className="w-full h-full"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
